import React, { Component } from 'react';
import ethereum from 'decentralized/ethereum.js';
import { Button, InputGroup, InputGroupAddon, InputGroupText, Input } from 'reactstrap';

class UserNameHowTo extends Component {
    constructor(props) {
        super(props);

        this.state = {
            value: '',
            pendingChange: false,
        };
    }

    chooseUserName() {
        ethereum.users.setUserName(this.state.value);
        this.props.onComplete(this.state.value);
    }

    onKeyPress(e) {
    }

    render() {
        if (!ethereum.isMetamaskInstalled()) {
            return (
                <div>
                  First install metamask.
                </div>
            );
        }
        return (
            <div onClick={(e) => e.stopPropagation()}>
              <InputGroup className="tag-sound-input">
                  <Input
                    onChange={(event) => {
                        this.state.value = event.target.value;
                        this.setState(this.state);
                    }}
                    value={this.state.value}
                    onKeyUp={(e) => this.onKeyPress(e)}
                    placeholder="Choose a user name" className="user-name-input"/>
                  <InputGroupAddon addonType="append">
                    <Button size="sm" onClick={() => this.chooseUserName()} color="secondary">Done</Button>
                  </InputGroupAddon>
                </InputGroup>
            </div>
        );
    }
}

export default UserNameHowTo;
